module.exports = __webpack_public_path__ + "img/folder.f999ba93.svg";